export default "__VITE_ASSET__BltsEFRY__"